/**
 * Whether a shoutout.fans page takes personalized-video orders.
 *
 * An unclaimed page (no owner yet, `talent_profiles.user_id` null) does not:
 * nobody would record the video. Its video card, the first-orders promo and
 * "$0 due today" stay hidden, the Become-a-Fan popup promises no video
 * discount, and the order page sends a direct link back to the page, which
 * offers the claim instead (JT via Creator Brain, Nicky's OK, 29 Oct 2026).
 */
export function pageTakesVideoOrders(page: { user_id?: string | null } | null | undefined): boolean {
  return !!page?.user_id;
}
